<template>
    <fields-list :fields="fields" :item="item" :name="name" />
</template>
<script>
/**Меняю добавление модалку */

import { multiKeyInit } from "../../plugins/functions";


export default {
  props: {
    name: {
      default: function () {
        return 'multiradio';
      },
    },
    value: {
      default: function () {
        return {};
      },
    },
    subFields: {
      default: function () {
        return [
          {
            key: "value",
            label: "Название",
            type: "html",
            textType: "text",
            isMultiLang: true,
          },
        ];
      },
    },
  },
  data: () => ({
    fields: [],
    item: {},
  }),
  methods: {
    multiKeyInit: multiKeyInit,
  },

  async created() {
   this.fields = await [...this.subFields];
   this.item = await this.multiKeyInit(this.value, this, 0);
  },
};
</script>

